import { BaseDto } from '../base.dto'
import { PagingDto } from '../paging.dto'
import { TranslationDto } from '../translation.dto'
import { MallDto } from '../mall.dto'
import { FloorDto } from './floor.dto'

export class TableDto extends BaseDto {
  /** Single string (legacy) or translation object */
  name: string | TranslationDto
  enabled: boolean
  mall?: MallDto
  floor?: FloorDto
  code?: string
  deeplink?: string

  static create({
    id,
    name,
    enabled,
    mall,
    floor,
    code,
    deeplink,
    createdAt,
    updatedAt
  }: Partial<TableDto>) {
    const normalizedName =
      name && typeof name === 'object' && 'en' in name
        ? name
        : TranslationDto.create(typeof name === 'string' ? name : '', '')
    return Object.assign(new TableDto(), {
      id: id || null,
      name: normalizedName,
      enabled: enabled ?? true,
      mall: mall || null,
      floor: floor || null,
      code: code || null,
      deeplink: deeplink ?? undefined,
      createdAt: createdAt || new Date(),
      updatedAt: updatedAt || new Date()
    })
  }
}

export class CreateTableDto {
  name: string
  enabled: boolean
  mallId: string
  floorId: string
}

export class UpdateTableDto {
  name?: string
  enabled?: boolean
  mallId?: string
  floorId?: string
}

export class FindTableDto extends PagingDto {
  searchText?: string
  mallId?: string
  floorId?: string
  enabled?: string
}

